export default {
  props: {
    show: {
      default: false
    }
  },
  data: function data() {
    return {
      showLoading: false
    };
  },
  watch: {
    show: {
      handler: function handler(newValue) {
        this.showLoading = newValue;
      }
    },
    showLoading: {
      handler: function handler(newValue) {
        this.$emit('update:show', newValue);
      }
    }
  }
};
const __FLY_DATA_ = {};